import React from 'react';

import SelectFilter from 'components/search_sidebar/select_filter';
import Wrapper from './wrapper';

import type { Filters } from './types';

const options = [
  { label: 'All Sources', value: null },
  { label: 'Contact', value: 'Backoffice::Contact' },
  { label: 'Deal', value: 'Apex::Deal' },
  { label: 'Listing', value: 'Project' },
];

type Slice = Pick<Filters, 'parentType'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ parentType, onChange }: Props) {
  return (
    <Wrapper>
      <SelectFilter
        options={options}
        value={options.find(option => option.value === parentType)}
        onChange={({ value: parentType }) => onChange({ parentType })}
      />
    </Wrapper>
  );
}
